module.exports = __webpack_public_path__ + "media/images/logo-42ba5efccc99192b5da17f1f30cbe6ab.png";